import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import InvoicerecordpaymentEdit from "../InvoicerecordpaymentEdit";

function AdminInvoicePaymentEdit(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={4}
        childrenPage={<InvoicerecordpaymentEdit/>}/>
        </DataContext.Provider>
    )
}

export default AdminInvoicePaymentEdit;